export default __webpack_public_path__ + "static/media/ddf-film-box.f7cc10ee.jpg";